import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'tertiary';
  children: ReactNode;
  className?: string;
}

export default function Button({ 
  variant = 'primary', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'px-6 py-3 font-semibold transition-all duration-300 ease-out whitespace-nowrap cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg';
  
  const variantClasses = {
    primary: 'bg-[#0D1B2A] text-white hover:bg-[#2E8BC0] focus:ring-[#2E8BC0]',
    secondary: 'border-2 border-[#0D1B2A] text-[#0D1B2A] bg-transparent hover:bg-[#0D1B2A] hover:text-white focus:ring-[#0D1B2A]',
    tertiary: 'text-[#2E8BC0] bg-transparent hover:text-[#0D1B2A] underline-offset-4 hover:underline focus:ring-[#2E8BC0]'
  };

  return (
    <button 
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
